module.exports = __webpack_public_path__ + "static/mm-cta-88297bc9fb9816e50bae04f156810889.jpg";